import PropTypes from "prop-types";
import React from "react";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomInput";
import { formatDateTime } from "functions/Helper";

export default function View({ tfsFee }) {
  return (
    <GridContainer>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Effective Date"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            value: formatDateTime(new Date(tfsFee.effectiveDate + "Z")),
            disabled: true
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Look Up Code"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            value: tfsFee.lookUpCode,
            disabled: true
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="IDR"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            value: tfsFee.idr,
            disabled: true
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="SGD"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            value: tfsFee.sgd,
            disabled: true
          }}
        />
      </GridItem>
    </GridContainer>
  );
}

View.propTypes = {
  tfsFee: PropTypes.object
};
